import { createEventBus } from '@/event-bus';

export const dataPinningEventBus = createEventBus();
